import type { Volume } from '../types/offer'

export const volumes: Volume[] = [
  {
    number: '1',
    title: 'THE SUNDAY LOSS',
    description:
      'The psychology of how Argentina transformed their greatest pain into their greatest strength. Learn how to do the same with your failures.',
    cover: 'https://cdn.magicpatterns.com/uploads/gieKPipiF4duEA8uQSXcdi/TOMO-1.png',
  },
  {
    number: '2',
    title: 'THE POTRERO SACRED CODE',
    description:
      'Discover the street-level mindset code that creates champions from humble beginnings. (Direct application to Bangladesh context)',
    cover: 'https://cdn.magicpatterns.com/uploads/2fVkAsdribYKgenyPPfdiL/TOMO-2.png',
  },
  {
    number: '3',
    title: 'THE GENEALOGY OF GODS',
    description:
      'The hidden lineage of Argentine excellence. Understand the generational mindset that produces world-class results.',
    cover: 'https://cdn.magicpatterns.com/uploads/qqDpp3AEf4dhiQCdFmspaP/TOMO-3.png',
  },
  {
    number: '4',
    title: 'THE PENALTY MINDSET',
    description:
      'Master the psychology of high-pressure moments. Use this framework in exams, job interviews, client negotiations, and critical business decisions.',
    cover: 'https://cdn.magicpatterns.com/uploads/piJXrEKVGBsvgZHodV5SSH/TOMO-4.png',
  },
  {
    number: '5',
    title: 'TWO HEARTS, ONE BEAT',
    description:
      'The duality of Argentine culture and how to harness conflicting identities for unstoppable resilience.',
    cover: 'https://cdn.magicpatterns.com/uploads/4HVgZij8Trj11mizWNHdHZ/TOMO-5.png',
  },
  {
    number: '6',
    title: 'THE ARCHITECT LEGACY',
    description:
      'Build your personal system of excellence. Design your life as a masterpiece using Argentine architectural principles.',
    cover: 'https://cdn.magicpatterns.com/uploads/gWKLx52yPVg1KtF66eqh68/TOMO-6.png',
  },
]
